import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { API_URL } from "../../config.tsx";

interface CarBrands {
    id: string;
    value: string;
}

/**
 * Запрос списка марок автомобилей
 * @returns
 */
export const useCarBrandsRequests = (): [CarBrands[], boolean, Dispatch<SetStateAction<boolean>>] => {
    const [brands, setBrands] = useState<CarBrands[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    //Запрос списка марок автомобилей
    useEffect(() => {
        setIsLoading(true);
        fetch(`${API_URL}/car_brands`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(brands => {
                setBrands(brands);
            })
            .finally(() => setIsLoading(false));
    }, []);

    return [brands, isLoading, setIsLoading];
}
